import React from 'react'

import { Modal, Button, Header, Input } from 'semantic-ui-react'

import './WrongLabelModal.css'


const WrongLabelModal = ({ open, onClose }) => {

  const inputRef = React.createRef()

  const focusInput = () => {
    if (open && inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }

  const onInputBlur = () => {
    focusInput();
  }

  const onInputKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      onClose();
    }
  }

  return (
    <Modal
      open={open}
      size="small"
      className="WrongLabelModal"
    >
      <Header className="Header" icon='warning sign' content={"FEL FRAKTETIKETT!"} />
      <Modal.Content className="Content">
        <h1>{"ÖPPNA LÅDA OCH KONTROLLERA VAROR!"}</h1>
        <Input
            autoFocus
            autoComplete="off"
            ref={inputRef}
            onBlur={() => onInputBlur()}
            onKeyPress={(ev) => onInputKeyPress(ev)} 
            style={{opacity:0,position:"absolute"}}/>
      </Modal.Content>
      <Modal.Actions className="Actions" color="red">
        <Button onClick={onClose}>
          OKEJ
              </Button>
      </Modal.Actions>
    </Modal>
  )
}


export default WrongLabelModal;










